import { Slide } from '../../types/elearning';
import ComponentRenderer from './content/ComponentRenderer';

interface ModuleSlideProps {
  slide: Slide;
}

export default function ModuleSlide({ slide }: ModuleSlideProps) {
  // Sort components by order
  const sortedComponents = [...slide.components].sort((a, b) => a.order - b.order);

  return (
    <div className="mb-12 last:mb-0">
      <div className="space-y-4">
        {sortedComponents.map((component) => (
          <ComponentRenderer key={component.id} component={component} />
        ))}
      </div>
    </div>
  );
}

